import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF, FaTiktok, FaYoutube } from 'react-icons/fa';
import kykylogo from '../assets/kyky-logo.png';

import '../styles/Footer.scss';

const Footer = () => {
  const { t } = useTranslation();

  const content = [
    {
      title: t('footer.discover'),
      link: [
        { to: '/#popular-services', label: t('footer.search for service') },
        { to: '/search', label: t('footer.find freelancer') }
      ]
    },
    {
      title: t('registration.company'),
      link: [
        { to: '/about-us', label: t('footer.team') },
        { to: '/how-service-works', label: t('footer.service-works') },
        { to: '/contact-us', label: t('footer.contact') }
      ]
    },
    {
      title: t('footer.support'),
      link: [
        { to: '/terms-of-service', label: t('footer.terms of service') },
        { to: '/privacy-policy', label: t('footer.privacy policy') },
        { to: '/kyky-faqsFi', label: t('footer.helps-faq') }
      ]
    }
  ];

  return (
    <footer className="footer-container">
      <div className="footerStart">
        <div className="row custom-padding">
          <div className="col-xl-10 col-12 row" style={{ rowGap: '36px' }}>
            {content.map((item, index) => (
              <div
                className={`col-md-4 col-12 d-flex flex-column footer-section footer-section-${index}`}
                key={index}
                style={{ rowGap: '24px' }}>
                <div className="text-xl text-white font-semibold footer-title">{item.title}</div>
                <div
                  className="d-flex flex-column footer-content"
                  style={{ color: 'white', fontSize: '16px', rowGap: '12px' }}>
                  {item.link.map((link, linkIndex) => (
                    <Link to={link.to} key={linkIndex}>
                      <div className="content">{link.label}</div>
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div
            className="col-xl-2 col-md-4 col-12 d-flex flex-column footer-social"
            style={{ rowGap: '24px' }}>
            <div className="text-xl text-white font-semibold footer-title">
              {t('footer.follow us')}
            </div>
            <div className="social-box d-flex flex-row" style={{ columnGap: '16px' }}>
              <div className="social-icon content">
                <a
                  href="https://www.linkedin.com/company/katchtoday"
                  target="_blank"
                  rel="noopener noreferrer">
                  <svg
                    className="linkedin"
                    xmlns="http://www.w3.org/2000/svg"
                    width="30px"
                    height="30px"
                    viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93zM6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37z"
                    />
                  </svg>
                </a>
              </div>
              <div className="social-icon content">
                <a
                  href="https://www.instagram.com/katch.today"
                  target="_blank"
                  rel="noopener noreferrer">
                  <FaInstagram size={30} className="instagram" />
                </a>
              </div>

              <div className="social-icon content">
                <a
                  href="https://www.facebook.com/katchdottoday/"
                  target="_blank"
                  rel="noopener noreferrer">
                  <FaFacebookF size={30} className="facebook" />
                </a>
              </div>

              <div className="social-icon content">
                <a
                  href="https://youtube.com/@katchtoday?si=F1GkS-sZTBbVoLhO"
                  target="_blank"
                  rel="noopener noreferrer">
                  <FaYoutube size={30} className="youtube" />
                </a>
              </div>

              <div className="social-icon content">
                <a
                  href="https://www.tiktok.com/@katchtoday?_t=ZS-8swWNHnXzd4&_r=1"
                  target="_blank"
                  rel="noopener noreferrer">
                  <FaTiktok size={30} className="tiktok" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footerEnd">
        <a href="/">
          <img src={kykylogo} alt="KykyLogo" className="logoImg" />
        </a>

        <p className="copyrightText">
          {t('footer.copyright')}© {new Date().getFullYear()} Katch Today
        </p>
      </div>
    </footer>
  );
};

export default memo(Footer);
